import React, {useState, useEffect, useRef} from "react";
import { NumericFormat } from 'react-number-format';

import { Editor } from '@tinymce/tinymce-react';

import { getProduto, salvarProduto, getListaProdutos } from "../componentes/api/DataApi";
import "../css/fake.css";

export default function EditProduto() {
    const editorDescricaoRef = useRef(null);
    const editorDescricaoDobroRef = useRef(null);
    const editorDescricaoLogadoRef = useRef(null);
    const editorPropostaRef = useRef(null);
    const editorPropostaRecorrenteRef = useRef(null);
    const editorPropostaDobroRef = useRef(null);
    const editorPropostaDobroRecorrenteRef = useRef(null);

    const [listaProdutos, setListaProdutos] = useState([]);
    const [produto, setProduto] = useState({
        id: "",
        codigo: "",
        descricao: "",
        descricao_logado: "",
        descricao_mobile: "",
        proposta: "",
        proposta_recorrente: "",
        codigo_caixa_1: "",
        codigo_caixa_2: "",
        valor: "",
        descricao_dobro: "",
        proposta_dobro: "",
        proposta_dobro_recorrente: "",
    });

    useEffect(() => {
        getListaProdutos((response) => {
            if (response) {
                setListaProdutos(response);
            }
        });
    }, []);

    const onSelecionaProduto = (e) => {
        if (e.target.value !== "") {
            console.log(e.target.value);

            getProduto(e.target.value, (response) => {
                console.log(response);
                
                if (response && response.codigo === 0) {
                    setProduto({...produto,
                        id: response.id,
                        codigo: response.codigoProduto,
                        descricao: response.descricao,
                        descricao_logado: response.descricao_logado,
                        descricao_mobile: (!response.descricao_mobile ? '' : response.descricao_mobile),
                        proposta: response.proposta,
                        valor: response.valor,
                        proposta_recorrente: response.propostaRecorrente ?? "",
                        codigo_caixa_1: response.codigoCaixa1,
                        codigo_caixa_2: response.codigoCaixa2,
                        descricao_dobro: response.descricao_dobro,
                        proposta_dobro: response.proposta_dobro,
                        proposta_dobro_recorrente: response.proposta_dobro_recorrente ?? "",
                    });
                }
                else {
                    setProduto({...produto,
                        id: "",
                        codigo: "",
                        descricao: "",
                        descricao_logado: "",
                        descricao_mobile: "",
                        proposta: "",
                        valor: "",
                        proposta_recorrente: "",
                        codigo_caixa_1: "",
                        codigo_caixa_2: "",
                        descricao_dobro: "",
                        proposta_dobro: "",
                        proposta_dobro_recorrente: "",
                    });
                }
            })
        }
        else {
            setProduto({...produto,
                id: "",
                codigo: "",
                descricao: "",
                descricao_logado: "",
                descricao_mobile: "",
                proposta: "",
                valor: "",
                proposta_recorrente: "",
                codigo_caixa_1: "",
                codigo_caixa_2: "",
                descricao_dobro: "",
                proposta_dobro: "",
                proposta_dobro_recorrente: "",
            });
        }
    }

    const SalvarProduto = () => {
        salvarProduto(produto, (response) => {
            if (response && response.codigo === 0) {
                alert("Produto salvo com sucesso!")
            }
            else {
                alert("Houve um erro na hora de gravar o produto (" + response.mensagem + ")");
            }
        })
    }

    return (
        <div className="fake-page bg-padrao">
            <div className="fake-page__container">
                <div className="fake-page__header">
                    <h1 className="colorTextoPadrao">Edição de Produto</h1>
                    <p>Selecione um produto e ajuste os conteúdos para salvar as alterações.</p>
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Dados Principais</h2>
                    <div className="fake-page__grid">
                        <div className="fake-page__field fake-page__field--full">
                            <label htmlFor="cbxTipoProduto">Selecione o produto</label>
                            <select id="cbxTipoProduto" value={produto.codigo} onChange={(e) => onSelecionaProduto(e)}>
                                <option value=""></option>
                                {listaProdutos?.map((item) => (
                                    <option key={item.id} value={item.codigoProduto}>{item.titulo} ({item.codigoProduto})</option>
                                ))}
                            </select>
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="tbxCodigo1">Código Caixa S/Recorrência</label>
                            <input type="text" id="tbxCodigo1" value={produto.codigo_caixa_1} onChange={(e) => setProduto({ ...produto, codigo_caixa_1: e.target.value })} />
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="tbxCodigo2">Código Caixa C/Recorrência</label>
                            <input type="text" id="tbxCodigo2" value={produto.codigo_caixa_2} onChange={(e) => setProduto({ ...produto, codigo_caixa_2: e.target.value })} />
                        </div>

                        <div className="fake-page__field">
                            <label htmlFor="tbxValor">Valor</label>
                            <NumericFormat id="tbxValor" value={produto.valor} decimalScale={2} onChange={(e) => setProduto({ ...produto, valor: e.target.value })} />
                        </div>

                        <div className="fake-page__field fake-page__field--full">
                            <label htmlFor="tbxDescricaoMobile">Descrição Mobile</label>
                            <input type="text" id="tbxDescricaoMobile" value={produto.descricao_mobile} onChange={(e) => setProduto({ ...produto, descricao_mobile: e.target.value })} />
                        </div>
                    </div>
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Descrição Sigpfweb</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxDescricao"
                        onInit={(evt, editor) => editorDescricaoRef.current = editor}
                        value={produto.descricao}
                        onEditorChange={(newValue, editor) => setProduto({...produto, descricao: newValue})}
                        init={{
                                selector: "textarea",
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Descrição Logado</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxDescricaoLogado"
                        onInit={(evt, editor) => editorDescricaoLogadoRef.current = editor}
                        value={produto.descricao_logado}
                        onEditorChange={(newValue, editor) => setProduto({...produto, descricao_logado: newValue})}
                        init={{
                                selector: "textarea",
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Proposta</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxProposta"
                        onInit={(evt, editor) => editorPropostaRef.current = editor}
                        value={produto.proposta}
                        onEditorChange={(newValue, editor) => setProduto({...produto, proposta: newValue})}
                        init={{
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Proposta (Recorrente)</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxPropostaRecorrente"
                        onInit={(evt, editor) => editorPropostaRecorrenteRef.current = editor}
                        value={produto.proposta_recorrente}
                        onEditorChange={(newValue, editor) => setProduto({...produto, proposta_recorrente: newValue})}
                        init={{
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Descrição Dobro</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxDescricaoDobro"
                        onInit={(evt, editor) => editorDescricaoDobroRef.current = editor}
                        value={produto.descricao_dobro}
                        onEditorChange={(newValue, editor) => setProduto({...produto, descricao_dobro: newValue})}
                        init={{
                                selector: "textarea",
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Proposta Dobro</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxPropostaDobro"
                        onInit={(evt, editor) => editorPropostaDobroRef.current = editor}
                        value={produto.proposta_dobro}
                        onEditorChange={(newValue, editor) => setProduto({...produto, proposta_dobro: newValue})}
                        init={{
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__card">
                    <h2 className="fake-page__section-title">Proposta Dobro (Recorrente)</h2>
                    <Editor
                        apiKey="6ts82oyd9h77gostgr4dkifarj6q24svylq1mpcz2lbbzy2s"
                        id="tbxPropostaDobroRecorrente"
                        onInit={(evt, editor) => editorPropostaDobroRecorrenteRef.current = editor}
                        value={produto.proposta_dobro_recorrente}
                        onEditorChange={(newValue, editor) => setProduto({...produto, proposta_dobro_recorrente: newValue})}
                        init={{
                                height: 500,
                                menubar: true,
                                plugins: [
                                    'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                                    'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                                    'media', 'table', 'emoticons', 'template', 'help'
                                  ],
                                toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>

                <div className="fake-page__actions">
                    <button type="button" className="botaoPadrao" onClick={() => SalvarProduto()}>Salvar</button>
                </div>
            </div>
        </div>
    )
}
